import { CircleAlert } from 'lucide-react'

import { Tooltip } from '~/components/component-library'
import { Timestamp } from '~/components/component-library/Timestamp'
import { SignerIcon } from '~/components/smart-accounts/SignerIcon'
import { OrgSigner } from '~/types'

export const PasskeyIconWithTooltip = ({
  signer,
  userPasskeys,
}: {
  signer: OrgSigner
  userPasskeys: OrgSigner[]
}) => {
  const {
    isArchived,
    lastVerifiedAt,
    providerIconLight,
    providerIconDark,
    id,
    name,
    createdAt,
  } = signer

  // defaulting to the name from userPasskey because it updates immediately after editing
  const userPasskey = userPasskeys.find((p) => p.id === id)

  return (
    <Tooltip
      content={
        <div className="flex max-w-40 flex-col gap-0.5 leading-tight">
          <span className="w-full truncate text-left text-xs font-medium">
            {userPasskey?.name ?? name ?? ''}
          </span>
          {isArchived && <RemovedTooltipText />}
          {!isArchived && (
            <LastUsedTooltipText lastVerifiedAt={lastVerifiedAt!} />
          )}
        </div>
      }
      className="relative flex h-6 w-6 items-center justify-center rounded-full border-[2px] border-white bg-gray-200 transition-[margin] duration-150 dark:border-black dark:bg-gray-800"
    >
      <>
        <SignerIcon
          signer={{
            id,
            name: name ?? '',
            createdAt,
            providerIconDark,
            providerIconLight,
          }}
          size={14}
        />
        {isArchived && (
          <div className="absolute m-[0_auto] flex h-full w-full items-center justify-center rounded-full border-2 border-orange-500">
            <div className="absolute -bottom-1 -right-1 flex h-3 w-3 items-center justify-center rounded-full bg-orange-500 text-[10px] font-bold text-white">
              !
            </div>
          </div>
        )}
      </>
    </Tooltip>
  )
}

export const RemovedTooltipText = () => (
  <>
    <span className="flex items-center text-xs text-orange-500">
      <CircleAlert className="mr-1 h-3 w-3" />
      Removed by owner
    </span>
    <span className="text-balance text-left text-xs text-secondary">
      We suggest removing this
      <br />
      passkey from this account
    </span>
  </>
)

export const LastUsedTooltipText = ({
  lastVerifiedAt,
}: {
  lastVerifiedAt?: Date | string
}) => (
  <span className="text-xs text-secondary">
    {lastVerifiedAt ? (
      <>
        Last used{' '}
        <Timestamp
          timestamp={new Date(lastVerifiedAt).getTime()}
          type="relative"
          abbreviate
          showTooltip={false}
        />
      </>
    ) : (
      'Not yet used'
    )}
  </span>
)
